import { BaseBody } from '../BaseBody.js';
import { CssVars } from '../../../util/CssVars.js';

const glyphname = 'petastiKentimataTripleYpsili';
const args = {};

export class PetastiKentimataTripleYpsili extends BaseBody {
  constructor() {
    super(glyphname, args);
  }
}
